import { twMerge } from 'tailwind-merge';

interface InfoWithIconProps {
  icon: React.ReactNode;
  text: string;
  containerClassName?: string;
  textClassName?: string;
}

export const InfoWithIcon = ({
  icon,
  text,
  containerClassName,
  textClassName,
}: InfoWithIconProps) => {
  return (
    <div className={twMerge('flex items-center gap-3', containerClassName)}>
      {icon}
      <div className={twMerge('text-sm text-gray-272727', textClassName)}>
        {text}
      </div>
    </div>
  );
};
